import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export const PaymentSuccess = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch (e) { /* retry */ }
      if (tries++ < 8) setTimeout(poll, 2000); else setStatus("paid");
    };
    poll();
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAF8F5] px-4" data-testid="payment-success-page">
      <div className="max-w-md rounded-3xl border border-stone-200 bg-white p-10 text-center shadow-sm">
        {status === "checking" ? (
          <>
            <Loader2 className="mx-auto h-12 w-12 animate-spin text-[#C85A32]" />
            <p className="mt-4 text-stone-600">{t("booking.payChecking")}</p>
          </>
        ) : (
          <>
            <CheckCircle2 className="mx-auto h-16 w-16 text-emerald-500" />
            <h1 className="mt-4 font-serif text-3xl text-stone-900">{t("booking.paySuccessTitle")}</h1>
            <p className="mt-3 text-stone-600">{t("booking.paySuccessText")}</p>
            <Button onClick={() => navigate("/")} className="mt-6 bg-[#C85A32] hover:bg-[#B04B26]" data-testid="pay-back-btn">{t("booking.payBack")}</Button>
          </>
        )}
      </div>
    </div>
  );
};

export const PaymentCancel = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAF8F5] px-4" data-testid="payment-cancel-page">
      <div className="max-w-md rounded-3xl border border-stone-200 bg-white p-10 text-center shadow-sm">
        <XCircle className="mx-auto h-16 w-16 text-stone-400" />
        <h1 className="mt-4 font-serif text-3xl text-stone-900">{t("booking.payCancelTitle")}</h1>
        <p className="mt-3 text-stone-600">{t("booking.payCancelText")}</p>
        <Button onClick={() => navigate("/")} variant="outline" className="mt-6" data-testid="pay-back-btn">{t("booking.payBack")}</Button>
      </div>
    </div>
  );
};
